import { createI18n } from 'vue-i18n'
import { watch } from 'vue'
import dayjs from 'dayjs'
import 'dayjs/locale/ru'
import 'dayjs/locale/de'
import 'dayjs/locale/fr'
import 'dayjs/locale/it'
import en from './locales/en.json'
import { activeLocale, resolveLocale, type Locale } from './locale'

const messages = import.meta.glob<{ default: typeof en }>('./locales/*.json')
const i18n = createI18n({ legacy: false, locale: 'en', fallbackLocale: 'en', globalInjection: true, messages: { en } as Record<string, typeof en> })
const pending = new Map<Locale, Promise<void>>()
let selection = 0

export async function loadLocale(locale: Locale): Promise<void> {
  if (i18n.global.availableLocales.includes(locale)) return
  let loading = pending.get(locale)
  if (!loading) {
    loading = (async () => {
      const module = await messages[`./locales/${locale}.json`]!()
      i18n.global.setLocaleMessage(locale, module.default)
    })().finally(() => pending.delete(locale))
    pending.set(locale, loading)
  }
  await loading
}

export async function setLocale(value: string): Promise<void> {
  const locale = resolveLocale(value)
  const request = ++selection
  await loadLocale(locale)
  if (request !== selection) return
  i18n.global.locale.value = locale
  window.localStorage.setItem('language', locale)
}

watch(
  i18n.global.locale,
  (value) => {
    activeLocale.value = resolveLocale(value)
    document.documentElement.lang = activeLocale.value
    dayjs.locale(activeLocale.value)
  },
  { immediate: true, flush: 'sync' },
)

export default i18n
